module.exports = __webpack_public_path__ + "img/ABLESDDetailed-min.b0b43c9e.png";